import React from "react";
import { useTranslation } from "react-i18next";
import SeoTemplatesForms from "./Forms";
import SeoTemplatesSkeleton from "./Skeleton";
import { useGetSEOTemplates } from "../../hooks/queries/seoTemplates";

export default function SeoTemplatesIndex(props) {
  const { t } = useTranslation();
  const { data, isError, isLoading } = useGetSEOTemplates();

  if (isError) return <p>{t("seoTemplates.messages.error")}</p>;
  if (isLoading) return <SeoTemplatesSkeleton />;
  if (!data) return <SeoTemplatesSkeleton />;
  
  // Handle both old and new data structure
  const initialData = {
    seo_templates: data.seo_templates || data, // New structure or fallback to old
    available_locales: data.available_locales || ['en'],
    current_locale: data.current_locale || 'en',
    localization_enabled: data.localization_enabled || false
  };
  
  return <SeoTemplatesForms initialData={initialData} />;
}
